<template>
    <div>
        <CustomSelectOne :name="name" :items="items" :empty-value="emptyValue" v-model="internalValue"
                         item-label="label" item-value="value" :label="label" v-if="loaded" @change="onChange"/>
    </div>
</template>

<script>
    import {getCategoryTypesUsingGET as getCategoryTypes} from "../../swagger/vue-api-client";
    import CustomSelectOne from "./inner/CustomSelectOne";

    export default {
        name: "CustomSelectOneCategoryType",
        props: {
            name: {
                type: String,
            },
            label: {
                type: String,
            },
            emptyValue: {
                type: Boolean,
                default: true,
            },
            modelValue: null,
            rules: undefined,
        },

        emits: ["update:modelValue", "change"],

        methods: {
            onChange(val) {
                if (val && val.value) {
                    this.$emit("change", val.value);
                } else {
                    this.$emit("change", undefined);
                }
            },
        },
        computed: {
            internalValue: {
                get() {
                    return this.modelValue;
                },
                set(value) {
                    this.$emit("update:modelValue", value);
                },
            },
        },

        data() {
            return {
                items: [],
                loaded: false,
            };
        },

        beforeMount() {
            getCategoryTypes().then((response) => {
                this.items = response.data;
                this.loaded = true;
            });
        },

        components: {CustomSelectOne},
    };
</script>

<style scoped>

</style>
